import { defineLabels, resolveLabels } from "@nexus/widget-sdk";

export const LABELS = defineLabels([
  { key: "performanceTab", name: "Performance view button", default: "Performance" },
  { key: "timelineTab", name: "Timeline view button", default: "Timeline" },
  { key: "liveEvents", name: "Live events caption", default: "Live" },
  { key: "allClear", name: "No anomaly caption", default: "No open anomalies" },
  { key: "next", name: "Next event caption", default: "Next" },
  { key: "upNext", name: "Upcoming list title", default: "Up next" },
  { key: "event", name: "Event column", default: "Event" },
  { key: "recent", name: "Recent events column", default: "Recent" },
  { key: "detections", name: "Detections column", default: "Detections" },
  { key: "responseCoverage", name: "Response coverage column", default: "Response" },
  { key: "targets", name: "Detection targets column", default: "Targets" },
  { key: "timeLeft", name: "Remaining time column", default: "Time left" },
  { key: "ended", name: "Event end time column", default: "Ended" },
  { key: "emptyLive", name: "Empty title (nothing live)", default: "No live events" },
  { key: "emptyAll", name: "Empty title (nothing scheduled)", default: "No events in this time range" },
  { key: "retry", name: "Retry button", default: "Retry" },
] as const);

export type EventMonitorLabels = ReturnType<typeof resolveLabels<typeof LABELS>>;

export const DEFAULT_LABELS: EventMonitorLabels = resolveLabels(LABELS, undefined);
